module.exports = __webpack_public_path__ + "img/earn-banner.eeacac9f.png";